import ConfigurableFlex from './_configurable-flex.js'
import ConfigurableFlexContainer from './_configurable-flex-container.js'
import ConfigurableFlexItem from './_configurable-flex-item.js'
import ConfigurablePosition from './_configurable-position.js'
import ConfigurablePadding from './_configurable-padding.js'
import ConfigurableSizeBounds from './_configurable-size-bounds.js'
import ConfigurableBackground from './_configurable-background.js'
import ConfigurableBorder from './_configurable-border.js'
import Text from './_text.js'

export default {
  name: 'DotNotification',
  values: {
    style: {
      rootContainer: {
        position: 'relative',
        $mixin: [
          {
            configSet: ConfigurableFlex,
          },
          {
            configSet: ConfigurableFlexContainer,
          },
          {
            configSet: ConfigurableFlexItem,
          },
          {
            configSet: ConfigurablePosition,
          },
          {
            configSet: ConfigurablePadding,
          },
          {
            configSet: ConfigurableSizeBounds,
          },
        ],
      },
      container: {
        position: 'absolute',
        $mixin: [
          {
            configSet: ConfigurableBackground,
          },
          {
            configSet: ConfigurablePadding,
          },
          {
            configSet: ConfigurablePosition,
          },
          {
            configSet: ConfigurableBorder,
          },
        ],
      },
      dot: {
        height: undefined,
        width: undefined,
        $mixin: [
          {
            configSet: ConfigurableBackground,
          },
          {
            configSet: ConfigurablePadding,
          },
          {
            configSet: ConfigurableBorder,
          },
        ],
      },
      dotWithText: {
        boxSizing: 'border-box',
        $mixin: [
          {
            configSet: ConfigurableBackground,
          },
          {
            configSet: ConfigurablePadding,
          },
          {
            configSet: ConfigurableBorder,
          },
          {
            configSet: ConfigurableSizeBounds,
          },
        ],
      },
    },
    text: {
      configSet: Text,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
